<section class="title-bar content-padding first-item content-padding">
    <div class="wrapper">
        <h2 class="left">{{ priorityList?.id ? "Modifica" : "Nuovo"}} Valet Priority List</h2>
        <br class="clear">
    </div>
</section>

<section class="content-padding darker">
    <div class="narrow-wrapper">
      <form class="has-cols" [formGroup]="priorityListForm" *ngIf="priorityListForm" (ngSubmit)="onSubmit()">
  
        <div class="col-48 grid-element">
            <label style="position: relative; top: 20px;">SELEZIONA IL PARTNER</label>
            <div>
              <div class="offer-products">
                <div class="" style="display: table; width: 100%;">
                  <label for=""></label>
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-product"></i>
                  </div>
                  <div class="product-q">
                    <div class="porduct-qty">
                      <div class="province-input">
                        <label for=""></label>
                        <ng-select 
                          formControlName="partner"
                          [searchable]="true" 
                          [clearable]="true"
                          [virtualScroll]="true"
                          >
                            <ng-option *ngFor="let partner of partners" [value]="partner.id">
                              {{ partner?.businessName }}
                            </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <br>
                  <app-error-html-handler [ctrl]="priorityListForm.get('partner')" [messages]="formValidationMsgs.partner"></app-error-html-handler>
                </div>
              </div>
            </div>
        </div>


        <div class="col-48 grid-element">
            <label style="position: relative; top: 20px;">Scegli la Provincia</label>
            <div>
              <div class="offer-products">
                <div class="" style="display: table; width: 100%;">
                  <label for=""></label>
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-product"></i>
                  </div>
                  <div class="product-q">
                    <div class="porduct-qty">
                      <div class="province-input">
                        <label for=""></label>
                        <ng-select formControlName="province">
                            <ng-option *ngFor="let province of provinces" [value]="province.id">
                                <b>{{ province?.provinceCode }}</b> {{ province?.province }}
                            </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <br>
                  <app-error-html-handler [ctrl]="priorityListForm.get('province')" [messages]="formValidationMsgs.province"></app-error-html-handler>
                </div>
              </div>
            </div>
        </div>

        <div class="grid-element-full">
          <label style="position: relative; top: 20px;">Seleziona il Valet</label>
          <div>
            <div class="offer-products">
              <div class="" style="display: table; width: 100%;">
                <div class="product-q">
                  <div class="porduct-qty">
                    <div class="province-input"> 
                      <label for=""></label>
                      <ng-select 
                        [(ngModel)]="selectedExpert" 
                        [ngModelOptions]="{standalone: true}"
                        [searchable]="true" 
                        [clearable]="true"
                        [virtualScroll]="true"
                        >
                          <ng-option *ngFor="let expert of experts" [value]="expert.id">
                              {{ expert?.user?.surname }} {{ expert?.user?.name }}
                          </ng-option>
                      </ng-select>
                    </div>
                  </div>
                </div>
                <br>
              </div>
            </div>
          </div>
          <div class="center" style="width: 100%;">
            <button class="btn mt-0" (click)="$event.preventDefault(); addExpertInDropList()">
              Aggiungi Valet<i class="ml-10 fas fa-plus"></i>
            </button>
          </div>
        </div>

        <!-- Drag and Drop -->
        <div cdkDropList class="example-list mt-20" (cdkDropListDropped)="drop($event)">  
          <div class="example-box" *ngFor="let expert of dragAndDropExpertsList, index as i" cdkDrag>
            <div class="drag-index">{{ i+1 }}</div>
              <div class="w-10 drag-icon">
                <i class="material-icons" cdkDragHandle>reorder</i>
              </div>
              <div class="w-100 drag-content">
                {{ expert?.user?.surname }} {{ expert?.user?.name }}
              </div> 
              <div class="w-10 delete-icon">
                <button mat-icon-button>
                  <i class="material-icons" (click)="removeExpertFromDropList(i, expert?.id)">delete_outline</i>
                </button>
              </div>
          </div>
        </div>
        <!-- Drag and Drop -->
  
        <div class="center" style="margin-top: 10px;">
          <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!priorityListForm.valid">
            Salva<i class="ml-10 far fa-save"></i>
          </button>
        </div>
        <div class="center" style="margin-top: 10px;">
          <button type="button" [routerLink]="['/valet/priority-list/duplica', priorityList?.id]" class="btn hvr-shrink center">
            Duplica<i class="ml-10 far fa-save"></i>
          </button>
        </div>
        
      </form>
      <br class="clear">
    </div>
</section>